import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import { t } from '@/i18n'

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.financial_transaction_detail.financial_transaction_label1'),
    link: '/financial',
  },
  {
    label: t('pages.financial_transaction_detail.financial_transaction_label2'),
  },
];
